import { type SbStoryParams } from "../types"

const DEFAULT_RESOLVE_RELATIONS = ["globalReference.componentReference"]

export function getResolveRelations(resolveRelations: SbStoryParams["resolve_relations"]) {
    if (!resolveRelations) return DEFAULT_RESOLVE_RELATIONS

    return [
        ...DEFAULT_RESOLVE_RELATIONS,
        ...(Array.isArray(resolveRelations) ? resolveRelations : [resolveRelations]),
    ]
}
